import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { FindingStatus, FINDING_STATUS_CONFIG } from '../../services/policy-gap-analysis.service';

@Component({
  selector: 'app-finding-status-badge',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span class="badge" [class]="badgeClass()">{{ label() }}</span>
  `,
})
export class FindingStatusBadgeComponent {
  status = input.required<FindingStatus>();

  label = computed(() => FINDING_STATUS_CONFIG[this.status()].label);
  badgeClass = computed(() => FINDING_STATUS_CONFIG[this.status()].bootstrapClass);
}
